import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { FaDownload } from "react-icons/fa"; // أيقونة التحميل
import { useTranslation } from "react-i18next"; 
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDark, setIsDark] = useState(true);
  const { t, i18n } = useTranslation(); 

  const themes = [
    { name: 'Blue', color: '#38bdf8' },
    { name: 'Green', color: '#22c55e' },
    { name: 'Purple', color: '#a855f7' },
    { name: 'Orange', color: '#f97316' },
    { name: 'Pink', color: '#ec4899' },



  ];

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
    setIsOpen(false); 
  };

  const toggleTheme = () => {
    setIsDark(!isDark);
    document.body.classList.toggle("light-theme");
  };

  const changePrimaryColor = (color) => {
    document.documentElement.style.setProperty('--primary-color', color);
    localStorage.setItem('pref-color', color);
  };

  useEffect(() => {
    const savedColor = localStorage.getItem('pref-color');
    if (savedColor) document.documentElement.style.setProperty('--primary-color', savedColor);
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <nav className="navbar">
      <div className="logo">Ziad<span>hamada</span></div>

      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/" onClick={() => setIsOpen(false)}>{t('nav_home')}</Link></li>
        <li><Link to="/about" onClick={() => setIsOpen(false)}>{t('nav_about')}</Link></li>
        <li><Link to="/projects" onClick={() => setIsOpen(false)}>{t('nav_projects')}</Link></li>
        <li><Link to="/contact" onClick={() => setIsOpen(false)}>{t('nav_contact')}</Link></li>
        
        {/* زرار الـ CV الجديد */}
     <li className="cv-item">
  <a 
    href="cv.pdf" // التعديل هنا: اسم الملف مباشرة مع الامتداد
    download="Ziad-Hamada-CV.pdf" // ده الاسم اللي هيظهر للمستخدم لما يحمل الملف
    className="cv-btn"
    onClick={() => setIsOpen(false)}
  >
    <FaDownload />
    <span>{t('') || "CV"}</span>
  </a>
</li>
        
        <div className="controls-mobile">
            <button className="lang-btn" onClick={toggleLanguage}>
              {i18n.language === 'en' ? 'AR' : 'EN'}
            </button>

            <div className="color-picker">
              {themes.map(theme => (
                <span 
                  key={theme.name} 
                  className="dot" 
                  style={{background: theme.color}} 
                  onClick={() => changePrimaryColor(theme.color)}
                ></span>
              ))}
            </div>

            <button className="theme-toggle" onClick={toggleTheme}>
              {isDark ? "Light" : "Dark"}
            </button>
        </div>
      </ul>

      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <HiX /> : <HiMenuAlt3 />}
      </div>
    </nav>
  );
}